import { MapTypes } from '@src/types/maps';
import { DEFAULT_THEME } from '@src/utils/constants/APP';
import {
  DARK_MAP_THEME_PIXXEL,
  LIGHT_MAP_THEME_PIXXEL,
  SATELLITE_MAP_MAPBOX
} from '@src/utils/constants/MAP_LAYERS';

import SatellitePreviewIcon from './satellite-preview.png';
import DarkPreviewIcon from './street-dark-preview.png';
import LightPreviewIcon from './street-light-preview.png';

interface MapStyles {
  name: MapTypes;
  thumbnail: string;
  value: string;
  uri: string;
}

const SatelliteMapStyle: MapStyles = {
  name: 'Satellite',
  thumbnail: SatellitePreviewIcon,
  value: 'mapbox://styles/' + SATELLITE_MAP_MAPBOX,
  uri: SATELLITE_MAP_MAPBOX
};

const LightThemeMapStyle: MapStyles = {
  name: 'Street',
  thumbnail: LightPreviewIcon,
  value: 'mapbox://styles/' + LIGHT_MAP_THEME_PIXXEL,
  uri: LIGHT_MAP_THEME_PIXXEL
};

export const DarkThemeMapStyle: MapStyles = {
  name: 'Street',
  thumbnail: DarkPreviewIcon,
  value: 'mapbox://styles/' + DARK_MAP_THEME_PIXXEL,
  uri: DARK_MAP_THEME_PIXXEL
};

export function getMapStyles(
  theme: string = DEFAULT_THEME
): [MapStyles, MapStyles] {
  const streetMapStyle =
    theme === 'light' ? LightThemeMapStyle : DarkThemeMapStyle;
  return [streetMapStyle, SatelliteMapStyle];
}
